export default __webpack_public_path__ + "static/media/c9.1dd3c5f0.PNG";